import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { INPUT_SIZES } from "../constants";
import { typographyBody1, typographyBody2 } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledBaseInputPrefixSuffix = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isDisabled', 'size'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  flex-shrink: 0;\n  overflow: hidden;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyBody1(theme);
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      theme = _ref2.theme;
  return isDisabled ? theme.color.text.light.disabled.value : theme.color.text.light.primary.value;
}, function (_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;
  return size === INPUT_SIZES.LARGE && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n      color: ", ";\n    "])), typographyBody2(theme), theme.color.text.light.primary.value);
});

var BaseInputPrefixSuffix = function BaseInputPrefixSuffix(props) {
  return /*#__PURE__*/_jsx(StyledBaseInputPrefixSuffix, _objectSpread({}, props));
};

BaseInputPrefixSuffix.displayName = "BaseInputPrefixSuffix";
BaseInputPrefixSuffix.propTypes = {
  /** If true, changes visual appearance */
  isDisabled: PropTypes.bool,

  /** Set the size of the input */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES))
};
BaseInputPrefixSuffix.defaultProps = {
  isDisabled: false,
  size: INPUT_SIZES.STANDARD
};
export { BaseInputPrefixSuffix };